<template>
    <div class="columns-row">
        <div class="columns_img img-scale-in">
            <a :href="$store.state.hrefPrefix + '/articles/' + article.slug + '?debate=' + debate.author_id">
                <img v-if="debate.author.blob != null" style="width: 80px" :src="debate.author.blob.url" alt=""/>
            </a>
        </div>
        <div class="columns_content">
            <h2>
                <a :href="$store.state.hrefPrefix + '/articles/' + article.slug + '?debate=' + debate.author_id">
                    <b>{{ debate.author.author_languages[0].pivot.name }}</b>

                </a>
            </h2>
            {{ debate.debate_languages[0].pivot.title }}
        </div>
    </div>
</template>

<script>
export default {
    name: "DebatersArticle",
    props: {
        article: {
            type: Object,
            default: null
        },
        debate: {
            type: Object,
            default: null
        }
    },
    computed: {
        formattedCreatedAt() {
            const date = new Date(this.debate.created_at.replace(' ', 'T'));
            const options = {month: 'short', day: 'numeric', year: 'numeric'};
            return date.toLocaleDateString(this.$store.state.language.code === 'ar' ? 'ar-LB' : 'en-US', options).toUpperCase();
        }
    }
}
</script>

<style scoped>

</style>
